export default __webpack_public_path__ + "static/Aeonik-Bold-a3a91f0710ce93317733e021dcf9c3dd.otf";